var map = {
	"./win-sign.png": 130,
	"./win-sign@2x.png": 132
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 187;



//////////////////
// WEBPACK FOOTER
// ./sprite ^\.\/win\-sign.*\.png$
// module id = 187
// module chunks = 3